import api from 'api';
import ApiService from 'api/ApiService';
import {DialogResult, DialogTypes} from 'common/names';
import {layoutActions, layoutTypes} from 'features/layout/redux';
import i18n from 'i18n';
import {call, put, SagaReturnType, take} from 'redux-saga/effects';
import {asyncSagaConstructor} from 'redux/common';
import {Partner} from 'types/partners';
import types from '../types';
import actions, {ICloseSubDialogAction} from 'features/layout/redux/actions';
import {castToSend} from 'common/yup/castToSend';
import {IPartner} from 'types/Partner';
import {FormOnSubmitHelpers} from 'components/hook-form/Formik';

function* openConfirmDialog() {
   yield put(
      layoutActions.openSubDialog({
         id: DialogTypes.ConfirmationDialog.id,
         title: i18n.t('Save Partner Confirmation'),
         content: i18n.t(
            `This Partner profile will be used immediately by jobs that reference this Partner.\nDo you still want to save this profile?`
         ),
      })
   );
   const result: ICloseSubDialogAction<string> = yield take(layoutTypes.CLOSE_SUB_DIALOG);
   return result?.payload?.result === DialogResult.OK;
}

export function* updatePartnerSaga(act: {
   type: string;
   payload: {data: IPartner; helpers?: FormOnSubmitHelpers<IPartner>};
}) {
   try {
      const {data} = act.payload;
      const isOk = (yield call(openConfirmDialog)) as SagaReturnType<typeof openConfirmDialog>;
      const payload = castToSend(Partner, data, {stripUnknown: true});

      if (isOk) {
         const postSaga = (yield call(
            asyncSagaConstructor,
            `${api.partners}/${data.id}`,
            types.UPDATE_PARTNER,
            {
               getMethod: ApiService.putSecureJson,
               data: payload,
            }
         )) as SagaReturnType<typeof asyncSagaConstructor>;
         yield call(postSaga);
         yield put(actions.loadTreeNav());
         return;
      }
   } catch (e) {
      console.error(e);
   } finally {
      act.payload?.helpers?.setSubmitting(false);
   }
}
